export const UPDATE_SUBSECTION_REQUEST = 'form/UPDATE_SUBSECTION_REQUEST';
export const UPDATE_SUBSECTION_SUCCESS = 'form/UPDATE_SUBSECTION_SUCCESS';
export const VALIDATE_FORM = 'form/VALIDATE_FORM';
export const VALIDATE_FORM_SUCCESS = 'form/VALIDATE_FORM_SUCCESS';
export const VALIDATE_FORM_FAILURE = 'form/VALIDATE_FORM_FAILURE';
export const UPDATE_SUBSECTION_ERRORS = 'form/UPDATE_SUBSECTION_ERRORS';
export const UPDATE_SUBSECTION_COMPLETE = 'form/UPDATE_SUBSECTION_COMPLETE';
export const UPDATE_CURRENT_SCROLL_VALUE = 'form/UPDATE_CURRENT_SCROLL_VALUE';
